<mat-card
    class="mb-25 tagus-card"
    [class.component-dark-theme]="themeService.isDark()"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <h5 class="mb-0">Browser Used & Traffic Reports</h5>
        <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
            <i class="ri-more-fill"></i>
        </button>
        <mat-menu #monthMenu="matMenu" class="monthMenu" xPosition="before">
            <button mat-menu-item type="button" class="bg-transparent border-none">Today</button>
            <button mat-menu-item type="button" class="bg-transparent border-none">Last Month</button>
            <button mat-menu-item type="button" class="bg-transparent border-none">Last Year</button>
            <button mat-menu-item type="button" class="bg-transparent border-none">All Time</button>
        </mat-menu>
    </mat-card-header>
    <mat-card-content>
        <div class="reports-table table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th class="fw-semibold main-color">Channel</th>
                        <th class="fw-semibold gray-color">Sessions</th>
                        <th class="fw-semibold gray-color">Previous Period</th>
                        <th class="fw-semibold gray-color">Transactions</th>
                        <th class="fw-semibold gray-color">Con.Rate</th>
                        <th class="fw-semibold gray-color">Avg.Time</th>
                        <th class="fw-semibold gray-color">Bounce Rate</th>
                        <th class="fw-semibold gray-color">% Change</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="main-color fw-semibold">Organic Search</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">3.2%</td>
                        <td class="gray-color fw-semibold">5:20</td>
                        <td class="gray-color fw-semibold">57.8%</td>
                        <td><span class="badge fw-semibold">52.80% <i class="flaticon-arrow-up"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">Direct</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">3.2%</td>
                        <td class="gray-color fw-semibold">5:20</td>
                        <td class="gray-color fw-semibold">57.8%</td>
                        <td><span class="badge fw-semibold">52.80% <i class="flaticon-arrow-up"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">Referal</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">3.2%</td>
                        <td class="gray-color fw-semibold">5:20</td>
                        <td class="gray-color fw-semibold">57.8%</td>
                        <td><span class="badge fw-semibold down">52.80% <i class="flaticon-down-filled-triangular-arrow"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">Email</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">3.2%</td>
                        <td class="gray-color fw-semibold">5:20</td>
                        <td class="gray-color fw-semibold">57.8%</td>
                        <td><span class="badge fw-semibold">52.80% <i class="flaticon-arrow-up"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">Social</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">3.2%</td>
                        <td class="gray-color fw-semibold">5:20</td>
                        <td class="gray-color fw-semibold">57.8%</td>
                        <td><span class="badge fw-semibold">52.80% <i class="flaticon-arrow-up"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">UC Browser</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">3.2%</td>
                        <td class="gray-color fw-semibold">5:20</td>
                        <td class="gray-color fw-semibold">57.8%</td>
                        <td><span class="badge fw-semibold">52.80% <i class="flaticon-arrow-up"></i></span></td>
                    </tr>
                    <tr>
                        <td class="main-color fw-semibold">Google</td>
                        <td class="gray-color fw-semibold">10853<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">566<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">12455<span class="muted-color fw-normal">(52%)</span></td>
                        <td class="gray-color fw-semibold">3.2%</td>
                        <td class="gray-color fw-semibold">5:20</td>
                        <td class="gray-color fw-semibold">57.8%</td>
                        <td><span class="badge fw-semibold down">52.80% <i class="flaticon-down-filled-triangular-arrow"></i></span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </mat-card-content>
</mat-card>